module.exports = __webpack_public_path__ + "media/images/index/area/faeture_setouchi-3d5b26a9e3a558ba8674276e29f89cf8.png";